/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Typography, Divider, TextField, IconButton } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete';

import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import CheckCircleOutlined from "@material-ui/icons/CheckCircleOutlined";

import Actions from '../../../fluid/Actions/ActionFactory'
import viewer_config from '../../Results/components/Config/viewer_config'

const clone = require('rfdc')()

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
          main: "#dc004e",
        },
    },
})

const styles = theme => ({

})

class FieldMap extends Component {
    state = {
        id : null,
        source_iu : null,
        source_iu_type : null,
        source_iu_fields : null,
        source_iu_fields_error : false,
        destination_iu : null,
        destination_iu_type : null,
        destination_iu_fields : null,
        destination_iu_fields_error : false,
        name : null,
        field_map : null,
        submit : false,
        fields_retreived : false
    }

    componentWillMount () {
        this.setState({...this.state,
            id : this.props.field_map.id,
            source_iu : this.props.field_map.sourceIU,
            destination_iu : this.props.field_map.destinationIU,
            name : this.props.field_map.name
        }, () => console.log("WF - FM On Load State : ", this.state))
    }

    componentDidMount () {
        Actions('http_request', {
            url : '/sainapse/information_channel/' + this.props.ic_name + '/information_unit/' + this.state.source_iu + '/field_in_scope',
            method : 'get',
            data : {}
        }).then(res => {
            console.log("WF - FM - Source Field : ", res.data.result)
            let source_fields = res.data.result.map(field => field.name)
            this.setState({...this.state, source_iu_fields : source_fields, source_iu_fields_error : false}, () => {
                Actions('http_request', {
                    url : '/sainapse/information_channel/' + this.props.ic_name + '/information_unit/' + this.state.destination_iu + '/field_in_scope',
                    method : 'get',
                    data : {}
                }).then(res => {
                    console.log("WF - FM - Destination Field : ", res.data.result)
                    let destination_fields = res.data.result.map(field => field.name)
                    let field_map = destination_fields.map(field => {
                        return {
                            "destination" : field,
                            "source" : []
                        }
                    })
                    this.setState({...this.state, destination_iu_fields : destination_fields, destination_iu_fields_error : false, field_map : field_map })
                }).catch(err => {
                    this.setState({...this.state, destination_iu_fields : null, destination_iu_fields_error : true })
                })
            })
        }).catch(err => {
            this.setState({...this.state, source_iu_fields : null, source_iu_fields_error : true})
        })
    }

    getAvatar = (type) => {
        let viewer_index = viewer_config.findIndex(viewer => viewer.type.includes(type))
        let avatar = viewer_config[viewer_index].avatar
        return React.createElement(avatar, { disabled: false });
    }

    updateFieldMap = (index, map) => {
        let new_state = clone (this.state)
        let field_map = new_state.field_map
        field_map[index].source = map

        this.setState({...new_state}, () => {
            console.log("WF - FM - Update: ", this.state)
            this.props.set_field_map(this.state.id, this.state.field_map)
        })
    }

    renderFields = () => {
        if (this.state.field_map !== null) {
            let fields = this.state.destination_iu_fields.map((field, i) => {
                return (
                    <Autocomplete
                        key = {i}
                        style = {{marginTop : '10px', marginBottom : '5px'}}
                        multiple
                        id="tags-standard"
                        openOnFocus
                        options={this.state.source_iu_fields}
                        groupBy = {(option) => this.state.source_iu + ' fields'}
                        onChange = {(event, newValue) => this.updateFieldMap(i, newValue)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                label= {field}
                            />
                        )}
                    />
                )
            })

            return fields
        }
    }

    renderCard = () => {
        return (
            <Paper elevation = {4} style = {{boxSizing : 'border-box', padding : '8px', width : '30%', height : '100%', maxHeight : '100%', overflow : 'scroll'}}>
                <div style = {{width : '100%', display : 'flex', flexDirection : 'row'}}>
                    <Typography variant = 'subtitle2' style = {{flexGrow : 1}}>{this.state.name}</Typography>
                </div>
                <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                <div style = {{width : '100%', display : 'flex', flexDirection : 'row', padding : '8px'}}>
                    <div style = {{flexGrow : 1}}>
                        {this.getAvatar(this.props.source_iu_type)}
                        <Typography style = {{marginTop : '5px'}} variant = 'caption'>{this.state.source_iu}</Typography>
                    </div>
                    <div style = {{flexGrow : 0, display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                        <ThemeProvider theme = {blue_theme}>
                            <ArrowRightAltIcon color = 'primary' fontSize = 'large'/>
                        </ThemeProvider>
                    </div>
                    <div style = {{flexGrow : 1}} align = 'right'>
                        {this.getAvatar(this.props.destination_iu_type)}
                        <Typography style = {{marginTop : '5px'}} variant = 'caption'>{this.state.destination_iu}</Typography>
                    </div>
                </div>
                <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                <Typography style = {{marginTop : '5px'}} variant = 'button' align = 'center'>{this.state.destination_iu} Fields</Typography>
                <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                {this.renderFields()}
            </Paper>
        )
    }

    render() {
        return this.renderCard()
    }
}

export default withStyles(styles)(FieldMap);